module.exports = __webpack_public_path__ + "img/delete-red.5ce61732.svg";